@if (data?.addToWallet || data.enableClose) {
	<button matMiniFab (click)="dialogRef.close()"
			style="position: absolute; inset-inline-end: 0.5rem; inset-block-start: 0.5rem; z-index: 10;">
		<mat-icon>close</mat-icon>
	</button>

}

@if (data.provider == 'CreditGuard') {
  <div class="cc-validation-disclaimer">
    <div>{{ 'MESSAGES.CREDIT_CARD_3DS_DISCLAIMER' | translate }}</div>
    <small>{{'MESSAGES.CREDIT_CARD_3DS_DISCLAIMER_more' | translate}}</small>
  </div>
}

@if (showAddToWallet && data.provider !== 'tabit') {
  <mat-checkbox
    class="save-to-wallet"
    name="updateWallet"
    (change)="markSaveToWalletPayment($event)"
    >
    {{'SAVE_ACCOUNT_PAYMENT_INFO' | translate}}
  </mat-checkbox>
}

<iframe id="ex_iframe" [src]="trustedIframeUrl" (load)="onFrameLoaded($event)" allow="payment" seamless="seamless"></iframe>
